// extracted by mini-css-extract-plugin
var _1 = "HSBVw";
export { _1 as "content" }
